export interface IUser {
  id: number;
  name: string;
  photo?: string;
  email: string;
  isMe?: boolean;
}

export enum enTypeUser {
  producer = 0,
  affiliate = 1
}
